GP.collections.UserList = Backbone.Collection.extend({
    model: GP.models.User,
    url: null, // this url will be set when the collection.fetch is called based off params passed to the collection/view
    comparator: function(data) {
        // return data.get('ctime');
    },
    parse: function(data) {
        // Hide "load more" button if no more users
        if (data.show_load_more === false) {
            GP.vent.trigger('User:toggle_more_users_button');
        }
        return data.content;
    },    
});
